/**
 * Procedures Service Hooks
 * React hooks for accessing Procedures Management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all Procedures Management services: `{ publicProcedures, proceduresMember, proceduresAdmin }`. */
export function useProceduresServices() {
    const { services } = useCCMS();
    if (!services?.procedures) {
        throw new Error('Procedures services not available. Ensure CCMSProvider is configured.');
    }
    return services.procedures;
}
/** Anonymous portal: lookups, ministries, public directory / procedure / runs (X-Run-Token) / chat. */
export function usePublicProceduresService() {
    return useProceduresServices().publicProcedures;
}
/** Signed-in portal (api/procedures/me). */
export function useProceduresMemberService() {
    return useProceduresServices().proceduresMember;
}
/** Console admin (api/procedures/admin). */
export function useProceduresAdminService() {
    return useProceduresServices().proceduresAdmin;
}
//# sourceMappingURL=useProceduresServices.js.map